import { Component, Input } from '@angular/core';
import { PurchaseOption } from 'src/app/shared/models/app-models/PurchaseOption.model';

@Component({
  selector: 'app-options-section',
  templateUrl: './options-section.component.html',
  styleUrls: ['./options-section.component.scss'],
})
export class OptionsSectionComponent {
  tabHeader: string = '';
  @Input() optionsList: PurchaseOption[] = [];
  @Input() imgPath: string = "unauthorized person";
  @Input() sectionTitle: string = "title";
  @Input() sectionText: string = "text";
}
